import React, { useState } from "react";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import type { UnitGroup } from "@/types";

interface UnitDimensionProps {
    unitGroup: UnitGroup;
}

export const UnitDimension: React.FC<UnitDimensionProps> = ({ unitGroup }) => {
    const [openId, setOpenId] = useState<number | null>(null);
    const representativeUnit = unitGroup.representative_unit;
    const category = representativeUnit.category;
    const hasWidth = representativeUnit.width !== 0;
    const hasLength = representativeUnit.length !== 0;

    const dimensionLabel = hasWidth && hasLength
        ? `${representativeUnit.width}' x ${representativeUnit.length}'`
        : hasWidth
            ? `${representativeUnit.width}'`
            : hasLength
                ? `${representativeUnit.length}'`
                : "";

    return (
        <>
            {category.description ? (
                <TooltipProvider>
                    <Tooltip
                        open={openId === category.id}
                        onOpenChange={(isOpen) => setOpenId(isOpen ? category.id : null)}
                    >
                        <TooltipTrigger asChild>
                            <span
                                onClick={() =>
                                    setOpenId(openId === category.id ? null : category.id)
                                }
                            >
                                {dimensionLabel !== "" && <span className="category-icon"></span>}
                                {dimensionLabel}
                            </span>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{category.description}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            ) : (
                <span>{dimensionLabel}</span>
            )}
        </>
    );
}
